import { Mail, MapPin, UserRound } from "lucide-react";

import type { TrustComplaint } from "@/api/trust_complaints";
import { trustComplaintAddressLine } from "@/components/trust_suite/trustSuiteDisplay";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

type ComplaintContactCardProps = {
  complaint: TrustComplaint;
};

export function ComplaintContactCard({ complaint }: ComplaintContactCardProps) {
  const addressLine = trustComplaintAddressLine(complaint.address_data);
  const hasContact = Boolean(complaint.contact_name || complaint.contact_email);

  if (!hasContact && !addressLine) {
    return (
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-base">Contact & location</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">No contact or location provided.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Contact & location</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm text-muted-foreground">
        {complaint.contact_name ? (
          <p className="flex items-center gap-2">
            <UserRound className="h-4 w-4 shrink-0" />
            <span>{complaint.contact_name}</span>
          </p>
        ) : null}
        {complaint.contact_email ? (
          <p className="flex items-center gap-2">
            <Mail className="h-4 w-4 shrink-0" />
            <a href={`mailto:${complaint.contact_email}`} className="text-primary hover:underline">
              {complaint.contact_email}
            </a>
          </p>
        ) : null}
        {addressLine ? (
          <p className="flex items-start gap-2">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0" />
            <span>{addressLine}</span>
          </p>
        ) : null}
      </CardContent>
    </Card>
  );
}
